<template>
  <!-- 包一层是因为放在 Dialog 里面，随时会销毁， -->
  <!-- 不然 this.player.dispose() 销毁后整个dom都没有了，会显示dom节点找不到的报错 -->
  <div ref="videoContainer" class="video-box">
    <!-- video-js有这个才有样式 -->
    <video ref="videoPlayer" class="video-js" />
  </div>
</template>

<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default {
  name: "VideoContainer",
  props: {
    src: {
      type: String,
      // http://www.tvyan.com/
      // 随便找个电视台直播进去复制一个 .m3u8 视频流链接就可以了
      default: "",
    },
  },
  data() {
    return {
      player: null,
    };
  },
  computed: {
    options() {
      return {
        playbackRates: [0.5, 1.0], // 播放速度
        autoplay: true,
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            // 这样是支持.m3u8  网上找到的各卫视直播视频流都是此格式
            type: "application/x-mpegURL", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            // type: 'video/mp4',
            src: this.src, // url地址
          },
        ],
        poster: "", // 你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后重新尝试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controls: true,
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          fullscreenToggle: true, // 全屏按钮
        },
        // 获取父元素的宽高
        width: this.$refs.videoContainer?.parentElement.offsetWidth || "356",
        height: this.$refs.videoContainer?.parentElement.offsetHeight || "200",
      };
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    init() {
      this.player = videojs(this.$refs.videoPlayer, this.options, function () {
        // console.log("onPlayerReady", this);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
